import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled } from '@zenbusiness/zui/styles';

export const Root = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
  height: '100%',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row'
  }
}));

export const Image = styled(SharedAsset)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    width: '22.5rem'
  },

  [theme.breakpoints.up('lg')]: {
    width: '26.25rem'
  }
}));

export const CardContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2),
  width: '100%',
  justifyContent: 'start',
  alignItems: 'center',

  [theme.breakpoints.up('lg')]: {
    padding: `${theme.spacing(2)} ${theme.spacing(10)}`
  }
}));

export const CardButton = styled(Button)(({ theme }) => ({
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    width: 'fit-content'
  }
}));

export const CardFooter = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: '1rem',
  right: '1.5rem',
  display: 'flex',
  alignItems: 'center',

  [theme.breakpoints.up('sm')]: {
    bottom: '1.5rem',
    right: '2rem'
  }
}));

export const Logo = styled(SharedAsset)(() => ({
  width: '5.5rem',
  height: '1.25rem'
}));
